export const METER_SETTING_EVENTS = {
  EXPIRY_DATE_CHANGE: "Expiry Date Change",
  OVERRIDE_ON: "Override On",
  OVERRIDE_OFF: "Override Off",
  OVERRIDE_DISABLED: "Override Disabled",
  ENERGY_TRADING_CHANGE: "Energy Trading Change",
};

export const UPDATES_PAGE_SIZE = 10;
